import React, { PropTypes, Component } from 'react';
import analytics from 'helpers/universalAnalytics';
import Plyr from 'plyr';


export default class VideoPlayer extends Component {
  static propTypes = {
    controls: PropTypes.bool
  };

  static defaultProps = {
    controls: false
  };

  _playPause() {
    var video = this.refs.video.getDOMNode();
    if (video.paused === true) {
      video.play();
    } else {
      video.pause();
    }
  }
  _mute() {
    var video = this.refs.video.getDOMNode();
    if (video.muted === false) {
      video.muted = true;
    } else {
      video.muted = false;
    }
  }
  _seek(e) {
    var video = this.refs.video.getDOMNode();
    var time = video.duration * (e.target.value / 100);
    video.currentTime = time;
  }
  // _componentDidMount() {
  //   var video = this.refs.video.getDOMNode();
  //   video.addEventListener('timeupdate', e => {
  //     var value = 100 / video.duration * video.currentTime;
  //     this.refs.seekBar.getDOMNode().value = value;
  //   });
  // }

  componentDidUpdate() {
    const videoModuleInvert = JSON.parse(localStorage.getItem('videoModuleInvert'));
    this.player = new Plyr(this.refs.video, {
      controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen',],
      settings: ['captions', 'quality', 'speed', 'loop'],
      invertTime: videoModuleInvert === null ? true : videoModuleInvert,
    });
    this.refs.video.addEventListener('play', (event) => {
      let pageId = Number(document.location.href.split("/").pop());
      analytics.event('video_player', `video_interaction`, { eventLabel: pageId });
    });
    this.player.increaseVolume(0);
    this.player.on('click',(e) => {
      if (e.target.ariaLabel === 'Current time') {
        localStorage.setItem('videoModuleInvert', JSON.stringify(!this.player.config.toggleInvert))
      }
    })
  }

  formatForAndroid(sources) {
    return sources.sort((first) => {
      if (first.type === 'mp4') {
        return -1
      } else {
        return 1
      }
    })
  }

  render() {
    var thesources = [];
    const sources = /Android/i.test(navigator.userAgent)
        ? this.formatForAndroid(this.props.sources)
        : this.props.sources

    thesources = sources.map(source => {
      if (source.url && source.url.toString().indexOf(source.type) !== -1) {
        return (
          <source
            src={source.url}
            type={'video/' + source.type}
            key={source.type}
          />
        );
      } else {
        return (
          <source
            src={source.url + '.' + source.type}
            type={'video/' + source.type}
            key={source.type}
          />
        );
      }
    });

    
    return (
      <div className="media-player">
        <video ref="video" controls>
          {thesources}
        </video>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/VideoPlayer.js